// Initialize all event listeners
document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {

        anchor.addEventListener('click', function(e) {

            const target = document.querySelector(this.getAttribute('href'));

            if (!target) return;

            e.preventDefault();

            const headerHeight = document.querySelector('header')?.offsetHeight || 200;

            const targetPosition =
                target.offsetTop - headerHeight;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });

        });

    });

});


// Scroll to top function
function scrollToTop() {
    window.scrollTo({
        top: 200,
        behavior: 'smooth'
    });
}